import React from 'react';
import { ArticleRow } from './ArticleRow';
import { LatestIssues } from './LatestIssues';
const brandsArticles = [{
  imageUrl: 'https://cdn.magicpatterns.com/uploads/egGhQMa5kXRGZgVh9psnaZ/Rectangle_234.jpg',
  title: 'StickyGinger appointed PR agency for RAKTDA across GCC',
  description: 'StickyGinger has been named the official public relations partner for the Ras Al Khaimah Tourism Development Authority (RAKTDA) in the GCC region.',
  category: 'NEWS'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/bmLyDXhyvzq5A6gvuty9qn/Rectangle_235.jpg',
  title: 'Vodafone, VML revive Abla Kamel in nostalgic Ramadan campaign',
  description: "Special Group, a global independent creative network, was the year's biggest climber in North America.",
  category: 'NEWS'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/tNfrrxgpqZJf3zQNWL2Pts/Rectangle_236_(1).jpg',
  title: 'The Future of DOOH Is Context, Not Coverage',
  description: 'As cities become more connected and behaviour around public spaces becomes more predictable, Digital Out of Home has entered a new phase.',
  category: 'NEWS'
}];
const agenciesArticles = [{
  imageUrl: 'https://cdn.magicpatterns.com/uploads/jUj2dmd6qK3PRWLkTrBDDD/Rectangle_234_(1).jpg',
  title: 'AppsFlyer appoints Alexia Nakad as GM for Western Europe and Middle East',
  description: 'AppsFlyer has appointed Alexia Nakad as General Manager for Western Europe and the Middle East, a newly created role aimed at accelerating...',
  category: 'NEWS'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/tCHxckx1pvNYjhmobrRVHY/Rectangle_235_(1).jpg',
  title: 'M&C Saatchi CEO Zaid Al-Qassab to step down',
  description: 'British advertising group M&C Saatchi said on Monday that its Chief Executive Officer, Zaid Al-Qassab, will step down from his position...',
  category: 'NEWS'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/niEnrLsGfKYFbKgiKCjAvv/Rectangle_236_(2).jpg',
  title: 'Jumeirah launches global cultural campaign centered on Arab hospitality',
  description: 'Criteo, the global platform connecting the commerce ecosystem for brands, agencies, retailers, and media owners, announced on Monday...',
  category: 'NEWS'
}];
export function SectionArticles() {
  return <section className="site-container mt-12 lg:mt-16 mb-12 lg:mb-16" data-id="element-267">
      <div className="flex flex-col lg:flex-row lg:items-start gap-8 lg:gap-4" style={{
      columnGap: '37px'
    }} data-id="element-268">
        {/* LEFT: Articles Rows */}
        <div className="flex-1 flex flex-col gap-12 min-w-0" data-id="element-269">
          <ArticleRow category="BRANDS" articles={brandsArticles} data-id="element-270" />
          <ArticleRow category="AGENCIES" articles={agenciesArticles} data-id="element-271" />
        </div>

        {/* RIGHT: Latest Issues Sidebar */}
        <div className="flex flex-col flex-shrink-0 w-full lg:w-[285px]" data-id="element-272">
          <LatestIssues data-id="element-273" />
        </div>
      </div>
    </section>;
}